import { TwitterLogo } from '@/assets/svg';
import BaseSocialModal from './BaseSocialModal';

export default class Twitter extends BaseSocialModal {
  constructor(props) {
    super(props, 'Twitter');
    this.logo = TwitterLogo;
  }

  render() {
    return this.renderSocialModal();
  }
}
